import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Chip from 'tio-ui/components/chip';
import TioAppearance from 'tio-common/components/tio/appearance';
import ProgramApprovalPage from 'tio-common/components/tas/program-approval/program-approval-page';
import ENV from 'tio-employee/config/environment';
import type { TasProgramInstanceExtension as TASProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { ISession } from 'tio-common/types/services';

interface RouteSignature {
  Args: {
    model: TASProgramInstanceModel;
  };
}

export default class TasProgramsRoute extends Component<RouteSignature> {
  @service declare session: ISession;

  <template>
    <ProgramApprovalPage @model={{@model}} @consumingApp="tio-employee">
      <:breadcrumb as |Crumb|>
        <Crumb
          @route="authenticated.admin.tas.approval-queue"
          @label={{t "tuition_assistance.approval_queue.title"}}
        />
        <Crumb @label={{@model.programName}} />
      </:breadcrumb>
      <:meta>
        <div class="tio-col-tight">
          {{! Status Chips }}
          <div class="tio-row-tight">
            <Chip @intent={{@model.badgeIntent}} @size="sm">
              {{@model.badgeLabel}}
            </Chip>
            {{#if @model.isTrial}}
              <Chip @intent="danger" @size="sm">
                {{t "common.trial"}}
              </Chip>
            {{/if}}
          </div>
          {{! Program Instance ID }}
          <div class="tio-text-base-semibold tio-fg-secondary">
            {{! template-lint-disable no-bare-strings }}
            Program #{{@model.id}}
          </div>
          {{! Employee Name and Payroll ID }}
          <div class="tio-row-snug text-sm tio-fg-muted">
            <LinkTo
              @route="authenticated.admin.employees.show"
              @model={{@model.employee.id}}
              class="font-semibold cursor-pointer truncate max-w-xs hover:underline"
            >
              {{@model.employee.person.fullName}}
            </LinkTo>
            <div class="tio-tas-meta-separator shrink-0"></div>
            <LinkTo
              @route="authenticated.admin.employees.show"
              @model={{@model.employee.id}}
              class="font-semibold tio-fg-primary shrink truncate max-w-40 cursor-pointer hover:underline"
              title={{@model.employee.payrollId}}
            >
              {{t "tuition_assistance.applications.payroll_id"}}
              {{@model.employee.payrollId}}
            </LinkTo>
            <div class="tio-tas-meta-separator shrink-0"></div>
            <span class="font-semibold truncate max-w-xs">
              {{@model.employee.company.name}}
            </span>
          </div>
        </div>
      </:meta>
      <:actions>
        {{#if @model.id}}
          <TioAppearance
            @apiKey={{ENV.apiKey}}
            @apiHost={{ENV.apiHost}}
            @token={{this.session.data.authenticated.access_token}}
            @type="tas_program_instance"
            @documentId={{@model.id}}
          />
        {{/if}}
      </:actions>
    </ProgramApprovalPage>
  </template>
}
